import React, { JSX, ReactNode, useEffect } from 'react'

export const OverlayShell = ({ children }: { children: ReactNode }): JSX.Element => {
  useEffect(() => {
    const originalBodyBg = document.body.style.background
    const originalRootBg = document.documentElement.style.background
    document.body.style.background = 'transparent'
    document.documentElement.style.background = 'transparent'

    const meta = document.createElement('meta')
    meta.name = 'referrer'
    meta.content = 'no-referrer'
    document.head.appendChild(meta)

    return () => {
      document.body.style.background = originalBodyBg
      document.documentElement.style.background = originalRootBg
      meta.remove()
    }
  }, [])

  return (
    <div
      data-testid='overlay-shell'
      className='w-full'
    >
      {children}
    </div>
  )
}
